import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ContentDataService } from '@pages/info-center/services/content-data.service';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, TranslateModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent implements OnInit, OnDestroy {

  faqs: any[] = [];
  faqs_main: any = [];
  faqsLength = 0;
  isSkeletonFaqsMain = true;

  private readonly isBrowser: boolean;
  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentDataService: ContentDataService,
    private sanitizer: DomSanitizer,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.contentDataService.getFAQ()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.faqs_main = res?.main_description?.length ? res.main_description[0].answer : (res?.main_description ?? []);
        this.faqs = res?.faq_contents?.rows ?? [];
        this.faqsLength = this.faqs.length;
        this.isSkeletonFaqsMain = false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  scroll(id: string | number): void {
    if (!this.isBrowser) return;
    const el = document.getElementById(String(id));
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  sanitize(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content ?? '');
  }
}
